import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldTask']),
        getByProject: (state) => idProject => {
            return state.objs.filter(task => task.project === idProject);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldTask']),
        deleteByProject: (state, idProject) => {
            state.objs.forEach((task, index) => {
                if(task.project = idProject){
                    state.objs.splice(index, 1);
                }
            });
        }
    },
    actions: {
        ...functions.createDefaultActions(),
        // ...functions.createDefaultActionsWithStore(['idWorldTask']),
        deleteByProject: ({ commit }, idProject) => {
            return new Promise(resolve => {
                commit('deleteByProject', idProject);
                resolve();
            });
        }
    }
}